import {CustomList} from "../../components/CustomList";
import {ApprovedInvoicesDatagrid} from "./ApprovedInvoicesDatagrid";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {ListProps, NullableBooleanInput} from "react-admin";
import {getDefaultListProps, initField} from "../../shared/utils";
import {DateInput} from "ra-ui-materialui";
import {TariffType} from "../../shared/types";


export function ApprovedInvoicesList(props: ListProps) {
    const { data: options } = useOptionsResource("GET");
    const filters = options ? [
        <NullableBooleanInput {...initField("chart_account_handle", options)} alwaysOn label="Piano dei conti assegnato" />,
        <DateInput source="invoice_date_after" label="Dal" />,
        <DateInput source="invoice_date_before" label="Al" />,
    ] : []
    return options ? (
        <CustomList
            {...getDefaultListProps(props)}
            filters={filters}
            filter={{ "invoice_type": TariffType.PURCHASE }}
            filterDefaultValues={{
                invoice_date_after: new Date(new Date().getFullYear(), 0, 1, 12).toISOString().split('T')[0],
            }}
            bulkActionButtons={false}
        >
            <ApprovedInvoicesDatagrid options={options}/>
        </CustomList>
    ) : null;
}